import { useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Editor } from "tldraw";

import { useEvent } from "@/components/hooks/useEvent";

export function useFullscreen({
  editorRef,
  defaultFullscreen = false,
}: {
  editorRef: React.RefObject<Editor | undefined>;
  defaultFullscreen?: boolean;
}) {
  const [fullscreen, setFullscreen] = useState(defaultFullscreen);
  const onFullscreenChange = useEvent((fullscreen: boolean) => {
    if (!editorRef.current) return;
    const oldViewport = editorRef.current.getViewportScreenBounds();

    // eslint-disable-next-line @eslint-react/dom/no-flush-sync
    flushSync(() => {
      // eslint-disable-next-line @eslint-react/hooks-extra/no-direct-set-state-in-use-effect
      setFullscreen(fullscreen);
    });

    function center() {
      if (editorRef.current) {
        const camera = editorRef.current.getCamera();
        const viewport = editorRef.current.getViewportScreenBounds();
        const scale = 1 / camera.z;

        editorRef.current.setCamera({
          y: camera.y,
          z: camera.z,
          x:
            camera.x +
            (viewport.width / 2) * scale -
            (oldViewport.width / 2) * scale,
        });
      }

      editorRef.current?.off("change", center);
    }

    editorRef.current?.on("change", center);
  });

  useEffect(() => {
    if (defaultFullscreen) {
      onFullscreenChange(true);
    }
  }, [defaultFullscreen, onFullscreenChange]);

  return [fullscreen, onFullscreenChange] as const;
}
